<div id="toolbar-buttons">
  @if( !userService.currentUser ) {
    <button mat-button (click)="login()">Sign In</button>
  }
</div>
<button mat-icon-button aria-label="Toggle mobile menu">
  <mat-icon id="snav-mobile-button" (click)="onToggleMobileMenu()">menu</mat-icon>
</button>
